import React, { Component } from "react";
import TagManager from "react-gtm-module";

class Simple extends Component {
  render() {
    // console.log(window.location.hostname)
    var domain_name = window.location.hostname;
    localStorage.setItem("domainName", domain_name);
    var domainApp = localStorage.getItem("domainName");
    if (domainApp === "localhosts") {
      // console.log('WORLD APP')
      // localStorage.setItem("domainApp", "WORLD");

      localStorage.setItem("domainApp", "CHINA");
    } else {
      // console.log('CHINA APP')
      // localStorage.setItem("domainApp", "CHINA");
      localStorage.setItem("domainApp", "WORLD");
    }
    const tagManagerArgs = {
      gtmId: "GTM-KF7B5DD",
      events: {
        sendUserInfo: "userInfo",
      },
      dataLayer: {
        page: "Sign up",
      },
    };
    TagManager.initialize(tagManagerArgs);
    return (
      <div className="">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <main id="main-content" tabIndex="-1">
          {this.props.children}
        </main>
        {/*<GoogleTagManager gtmId='GTM-KF7B5DD' scriptId='gtm-script-container' dataLayerName='dl-backup' additionalEvents='' previewVariables='' />*/}
      </div>
    );
  }
}

export default Simple;



// WEBPACK FOOTER //
// ./src/containers/Simple/Simple.js